import React, { useMemo, useState } from 'react'

import { Button, BUTTON_THEME, Input, INPUT_THEME } from '@st-operations/uikit/src/v2/index.js'

import AudienceDiff from '../components/audience-diff'

const PAGE_SIZE = 50

const ReviewStage = ({
  collection,
  plan,
  excludedIds,
  onToggleExclude,
  onClearExcluded,
  onBack,
  onStart,
}) => {
  const [search, setSearch] = useState('')
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  const changed = useMemo(() => plan.filter(({ changeCount }) => changeCount > 0), [plan])
  const unchangedCount = plan.length - changed.length
  const excludedCount = changed.filter(({ audience }) => excludedIds.has(audience._id)).length
  const includedCount = changed.length - excludedCount

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase()
    if (!term) return changed
    return changed.filter(
      ({ audience }) => audience.name.toLowerCase().includes(term) || audience._id.includes(term)
    )
  }, [changed, search])

  return (
    <div className="bulk-edit-review">
      <section className="bulk-edit__card">
        <header className="bulk-edit__card-header">
          <h3>3. Review before running — {collection.label}</h3>
        </header>

        <div className="bulk-edit__warning">
          This update runs entirely in your browser, one audience at a time. Keep this tab open
          until it finishes — closing it interrupts the process (progress is logged locally so you
          can retry what is missing).
        </div>

        <p className="bulk-edit__summary">
          <strong>{includedCount}</strong> audiences will be updated.
          <If condition={excludedCount > 0}>
            {' '}
            <strong>{excludedCount}</strong> removed from this run.{' '}
            <button type="button" className="bulk-edit-review__restore" onClick={onClearExcluded}>
              Add all back
            </button>
          </If>
          <If condition={unchangedCount > 0}>
            {' '}
            <strong>{unchangedCount}</strong> matched the query but are not affected by the changes
            and will be skipped.
          </If>
        </p>

        <Input
          className="bulk-edit-review__search"
          placeholder="Filter by name or ID"
          theme={INPUT_THEME.SEARCH}
          value={search}
          onChange={setSearch}
        />

        <div className="bulk-edit-review__list">
          <For each="item" of={filtered.slice(0, visibleCount)}>
            <AudienceDiff
              key={item.audience._id}
              audience={item.audience}
              changes={item.changes}
              href={collection.audienceUrl(item.audience._id)}
              excluded={excludedIds.has(item.audience._id)}
              onToggleExclude={onToggleExclude}
            />
          </For>
          <If condition={filtered.length > visibleCount}>
            <Button
              theme={BUTTON_THEME.SECONDARY}
              onClick={() => setVisibleCount((count) => count + PAGE_SIZE)}
            >
              Show more ({filtered.length - visibleCount} remaining)
            </Button>
          </If>
        </div>
      </section>

      <div className="bulk-edit__stage-actions">
        <Button theme={BUTTON_THEME.SECONDARY} onClick={onBack}>
          Back to Edit
        </Button>
        <Button onClick={onStart} disabled={includedCount === 0}>
          Start Bulk Update ({includedCount})
        </Button>
      </div>
    </div>
  )
}

export default ReviewStage
